var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',_vm._g(_vm._b({staticClass:"flex btn btn-outline bg-red-500 text-white-text btn-circle hover:bg-red-600 border-none btn-sm"},'button',_vm.$attrs,false),_vm.$listeners),[_c('font-awesome-icon',{attrs:{"icon":"trash"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }